<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="container-privacy">
            <div class="header-privacy">
                <h1><p>
                    AVISO DE <br> PRIVACIDAD DE <br> <span>USUARIO FINAL</span>
                </p></h1>
            </div>
            <div class="privacy-content">
                <p class="date">
                    Fecha de última actualización: 31 de marzo de 2021
                </p>
                <p>
                    <span>MUUK TECHNOLOGIES S. DE R.L. DE C.V.</span> en lo sucesivo <span>“FAD®”</span> con domicilio
                    ubicado en Fuente de
                    Pirámides # 1-604 Col. Lomas de Tecamachalco, Naucalpan, Estado de México, es una empresa
                    comprometida con la protección de datos personales y la privacidad de sus usuarios; en cumplimiento
                    a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y a su
                    Reglamento, así como a los más altos estándares y lineamientos a nivel nacional e internacional en
                    materia de protección de datos, ponemos a su disposición el siguiente Aviso de Privacidad:
                </p>
                <ol>
                    <li><span>FINALIDADES</span> <br><br>
                        <ol type="a">
                            <li>PRIMARIAS <br><br>
                                <ul>
                                    <li>Para brindarle el servicio comercialización de productos de Firma Autógrafa
                                        Digital y relacionados con ésta.
                                    </li>
                                    <li>Para que pueda tener acceso a sus compras.</li>
                                    <li>Para el acceso a nuestro sitio web e identificarlo y autenticarlo como
                                        usuario.
                                    </li>
                                    <li>Facturación.</li>
                                    <li>Tener un canal de comunicación con usted para servicio al cliente.</li>
                                    <li>Notificarle de los cambios y mantenimientos de los productos y/o servicios
                                        contratados.
                                    </li>
                                    <li>Para brindarle un soporte técnico.</li>
                                </ul>
                            </li>
                            <br>
                            <li>SECUNDARIAS:
                                <br><br>
                                <ul>
                                    <li>Para enviarle la publicidad de nuestros productos y servicios de nuestra Firma
                                        Autógrafa Digital.
                                    </li>
                                    <li>Realizar encuestas, implementar procesos analíticos y estadísticos con fines de
                                        mercadotécnica.
                                    </li>
                                </ul>
                                <br>
                                <p>Si usted se opone al tratamiento para finalidades secundarias, puede en cualquier
                                    momento contactarnos y manifestar su oposición al correo:
                                    privacidad@firmaautografa.com</p>
                            </li>
                        </ol>
                    </li>
                    <br>

                    <li><span>DATOS POR CATEGORIAS</span> <br><br>
                        <p>Para las finalidades antes mencionadas, recabamos los siguientes datos proporcionados por
                            usted.</p>
                        <ol type="a">
                            <li>DATOS PERSONALES<br><br>
                                <ul>
                                    <li>Nombre completo</li>
                                    <li>Domicilio</li>
                                    <li>Teléfono</li>
                                    <li>Correo electrónico</li>
                                    <li>País</li>
                                    <li>Estado</li>
                                    <li>Ciudad.</li>
                                    <li>Código Postal.</li>
                                </ul>
                            </li>
                            <br>
                            <li>DATOS FINANCIEROS
                                <br><br>
                                <ul>
                                    <li>RFC</li>
                                    <li>Nombre completo o razón social de la empresa que representa</li>
                                    <li>Número de tarjeta de crédito</li>
                                    <li>Fecha de vencimiento de la tarjeta</li>
                                    <li>CVV</li>
                                </ul>
                                <br>
                            </li>
                        </ol>
                    </li>

                    <li><span>TRANSFERENCIAS</span> <br><br>
                        <p>En <span>FAD®</span>, no realizamos transferencias de Datos Personales, salvo aquellas
                            previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión
                            de los Particulares.</p>
                    </li>
                    <br>

                    <li><span>EJERCICIO DE DERECHOS</span><br><br>
                        <p>En los términos permitidos por la normatividad aplicable, usted podrá acceder, rectificar y
                            cancelar sus datos personales, oponerse al tratamiento de estos, así como revocar en
                            cualquier momento el consentimiento que en su caso nos haya otorgado, a través del correo
                            electrónico:
                            <br><br>Su solicitud deberá contener:
                        </p>
                        <ul>
                            <li>Nombre completo</li>
                            <li>Copia simple o copia digital de identificación oficial para acreditar la identidad. (INE, pasaporte, cédula profesional)</li>
                            <li>Representación: En caso de actuar en representación de un menor, se deberá presentar acta de nacimiento o documento oficial donde se acredite la personalidad del padre o tutor; en caso de actuar en representación de un tercero mayor de edad, deberá adjuntar el poder donde se acrediten sus facultades para actuar en representación de éste.</li>
                            <li>Descripción breve de lo que solicita, ya sea el acceso a sus datos, rectificación o cancelación de éstos, oposición al tratamiento o algunas finalidades del tratamiento o revocación del consentimiento.</li>
                            <li>Para rectificar su nombre o domicilio, anexar copia de justificativo en caso de ser distinto a la identificación oficial presentada para acreditar la identidad.</li>
                        </ul>
                        <br>
                        <p>El plazo de respuesta será de 20 días hábiles con base en el calendario oficial publicado en
                            el Diario Oficial de la Federación.</p>
                        <p>La respuesta a su solicitud será enviada a través del mismo medio por el cual fue recibida,
                            es decir, vía correo electrónico.</p>
                        <p>En caso de no recibir respuesta de nuestra parte o si ella le resultara insatisfactoria,
                            usted cuenta con un plazo de 15 días hábiles para acudir al INAI y solicitar que se inicie
                            un procedimiento de protección de derechos.</p>
                    </li>

                    <li><span>MECANISMOS PARA LA LIMITACIÓN DEL USO Y DIVULGACIÓN DE LOS DATOS Y LA REVOCACIÓN DEL CONSENTIMIENTO</span><br><br>
                        <p>Usted podrá limitar el uso, divulgación de sus datos personales u oponerse al tratamiento de éstos para finalidades secundarias, a través del correo electrónico: privacidad@firmaautografa.com</p>
                    </li>

                    <li><span>MEDIDAS DE SEGURIDAD</span><br><br>
                        <p>El responsable, en atención al cumplimiento de los lineamientos que la Ley y su reglamento establecen, cuenta con un compromiso elevado en las medidas de seguridad: físicas, administrativas y tecnológicas necesarias para la protección de sus Datos Personales y Datos Financieros.</p>
                    </li>

                    <li><span>MODIFICACIÓN A LOS AVISOS DE PRIVACIDAD</span><br><br>
                        <p><span>FAD®</span> le notificará cualquier modificación o actualización al presente aviso de privacidad a través de correo electrónico.
                        </p>
                    </li>
                </ol>
                <br>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>Aviso de privacidad de usuario final</h1>
                <p class="text">
                    Fecha de última actualización: 31 de marzo de 2021
                </p>
                <p class="text">
                    <span>MUUK TECHNOLOGIES S. DE R.L. DE C.V.</span> en lo sucesivo <span>“FAD®”</span> con domicilio
                    ubicado en Fuente de
                    Pirámides # 1-604 Col. Lomas de Tecamachalco, Naucalpan, Estado de México, es una empresa
                    comprometida con la protección de datos personales y la privacidad de sus usuarios; en cumplimiento
                    a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y a su
                    Reglamento, así como a los más altos estándares y lineamientos a nivel nacional e internacional en
                    materia de protección de datos, ponemos a su disposición el siguiente Aviso de Privacidad:
                </p>
                <p class="text">
                    <span>En cumplimiento a los principios de información</span>, consentimiento, licitud y lealtad,
                    ponemos a su
                    disposición el siguiente Aviso de Privacidad:
                </p>
                <ol class="text">
                    <li><span>FINALIDADES</span> <br><br>
                        <ol type="a">
                            <li>PRIMARIAS <br><br>
                                <ul>
                                    <li>Para brindarle el servicio comercialización de productos de Firma Autógrafa
                                        Digital y relacionados con ésta.
                                    </li>
                                    <li>Para que pueda tener acceso a sus compras.</li>
                                    <li>Para el acceso a nuestro sitio web e identificarlo y autenticarlo como
                                        usuario.
                                    </li>
                                    <li>Facturación.</li>
                                    <li>Tener un canal de comunicación con usted para servicio al cliente.</li>
                                    <li>Notificarle de los cambios y mantenimientos de los productos y/o servicios
                                        contratados.
                                    </li>
                                    <li>Para brindarle un soporte técnico.</li>
                                </ul>
                            </li>
                            <br>
                            <li>SECUNDARIAS:
                                <br><br>
                                <ul>
                                    <li>Para enviarle la publicidad de nuestros productos y servicios de nuestra Firma
                                        Autógrafa Digital.
                                    </li>
                                    <li>Realizar encuestas, implementar procesos analíticos y estadísticos con fines de
                                        mercadotécnica.
                                    </li>
                                </ul>
                                <br>
                                <p>Si usted se opone al tratamiento para finalidades secundarias, puede en cualquier
                                    momento contactarnos y manifestar su oposición al correo:
                                    <a href="mailto:privacidad@firmaautografa.com">PRIVACIDAD</a>
                                    </p>
                            </li>
                        </ol>
                    </li>
                    <br>

                    <li><span>DATOS POR CATEGORIAS</span> <br><br>
                        <p>Para las finalidades antes mencionadas, recabamos los siguientes datos proporcionados por
                            usted.</p>
                        <ol type="a">
                            <li>DATOS PERSONALES<br><br>
                                <ul>
                                    <li>Nombre completo</li>
                                    <li>Domicilio</li>
                                    <li>Teléfono</li>
                                    <li>Correo electrónico</li>
                                    <li>País</li>
                                    <li>Estado</li>
                                    <li>Ciudad.</li>
                                    <li>Código Postal.</li>
                                </ul>
                            </li>
                            <br>
                            <li>DATOS FINANCIEROS
                                <br><br>
                                <ul>
                                    <li>RFC</li>
                                    <li>Nombre completo o razón social de la empresa que representa</li>
                                    <li>Número de tarjeta de crédito</li>
                                    <li>Fecha de vencimiento de la tarjeta</li>
                                    <li>CVV</li>
                                </ul>
                                <br>
                            </li>
                        </ol>
                    </li>

                    <li><span>TRANSFERENCIAS</span> <br><br>
                        <p>En <span>FAD®</span>, no realizamos transferencias de Datos Personales, salvo aquellas
                            previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión
                            de los Particulares.</p>
                    </li>
                    <br>

                    <li><span>EJERCICIO DE DERECHOS</span><br><br>
                        <p>En los términos permitidos por la normatividad aplicable, usted podrá acceder, rectificar y
                            cancelar sus datos personales, oponerse al tratamiento de estos, así como revocar en
                            cualquier momento el consentimiento que en su caso nos haya otorgado, a través del correo
                            electrónico:
                            <br><br>Su solicitud deberá contener:
                        </p>
                        <ul>
                            <li>Nombre completo</li>
                            <li>Copia simple o copia digital de identificación oficial para acreditar la identidad. (INE, pasaporte, cédula profesional)</li>
                            <li>Representación: En caso de actuar en representación de un menor, se deberá presentar acta de nacimiento o documento oficial donde se acredite la personalidad del padre o tutor; en caso de actuar en representación de un tercero mayor de edad, deberá adjuntar el poder donde se acrediten sus facultades para actuar en representación de éste.</li>
                            <li>Descripción breve de lo que solicita, ya sea el acceso a sus datos, rectificación o cancelación de éstos, oposición al tratamiento o algunas finalidades del tratamiento o revocación del consentimiento.</li>
                            <li>Para rectificar su nombre o domicilio, anexar copia de justificativo en caso de ser distinto a la identificación oficial presentada para acreditar la identidad.</li>
                        </ul>
                        <br>
                        <p>El plazo de respuesta será de 20 días hábiles con base en el calendario oficial publicado en
                            el Diario Oficial de la Federación.</p>
                        <p>La respuesta a su solicitud será enviada a través del mismo medio por el cual fue recibida,
                            es decir, vía correo electrónico.</p>
                        <p>En caso de no recibir respuesta de nuestra parte o si ella le resultara insatisfactoria,
                            usted cuenta con un plazo de 15 días hábiles para acudir al INAI y solicitar que se inicie
                            un procedimiento de protección de derechos.</p>
                    </li>

                    <li><span>MECANISMOS PARA LA LIMITACIÓN DEL USO Y DIVULGACIÓN DE LOS DATOS Y LA REVOCACIÓN DEL CONSENTIMIENTO</span><br><br>
                        <p>Usted podrá limitar el uso, divulgación de sus datos personales u oponerse al tratamiento de éstos para finalidades secundarias, a través del correo electrónico: privacidad@firmaautografa.com</p>
                    </li>

                    <li><span>MEDIDAS DE SEGURIDAD</span><br><br>
                        <p>El responsable, en atención al cumplimiento de los lineamientos que la Ley y su reglamento establecen, cuenta con un compromiso elevado en las medidas de seguridad: físicas, administrativas y tecnológicas necesarias para la protección de sus Datos Personales y Datos Financieros.</p>
                    </li>

                    <li><span>MODIFICACIÓN A LOS AVISOS DE PRIVACIDAD</span><br><br>
                        <p><span>FAD®</span> le notificará cualquier modificación o actualización al presente aviso de privacidad a través de correo electrónico.
                        </p>
                    </li>
                </ol>
            </div>

        </div>
    </div>

</app-template>
